import {observer} from "mobx-react";
import React from "react";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {ContentButtonTable} from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/payments_history/table/styled";


const ExternallyPay = observer(
    ({
         payment,
         onClickExternallyPay,
     }: {
        payment: PaymentEntity,
        onClickExternallyPay: (payment: PaymentEntity) => void
    }) => {
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        const getContent = (payment: PaymentEntity): React.ReactNode => {
            if (payment.eligibleExternallyPayment) {
                return (
                    <ContentButtonTable
                        onClick={() => onClickExternallyPay(payment)}
                        size={15}
                        color={colors.text}
                        background={colors.onBackground}
                        accent={colors.accent}
                    >
                        Considerar pago
                    </ContentButtonTable>
                )
            } else {
                return null;
            }
        }

        return (
            <>
                {getContent(payment)}
            </>
        )
    })
export default ExternallyPay;
